import createIcon from '../../createIcon';

/**
 * @component @name HolidayVillage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMjBWOC4zNUwxMy42NSA0SDEwLjgyTDE2IDkuMThWMjBIMThaTTIyIDIwVjYuNjlMMTkuMzEgNEgxNi40OEwyMCA3LjUyVjIwSDIyWk04IDRMMiAxMFYyMEg3VjE1SDlWMjBIMTRWMTBMOCA0Wk05IDEzSDdWMTFIOVYxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HolidayVillage = createIcon('HolidayVillage', [
  [
    'path',
    {
      d: 'M18 20V8.35L13.65 4H10.82L16 9.18V20H18ZM22 20V6.69L19.31 4H16.48L20 7.52V20H22ZM8 4L2 10V20H7V15H9V20H14V10L8 4ZM9 13H7V11H9V13Z',
      key: 'n380mn',
    },
  ],
]);

export default HolidayVillage;
